import src from "IMAGE";
export default { src, width: 695, height: 140, blurWidth: 0, blurHeight: 0};
